import Icons from "../../../../src/components/icons";
import { HeartFillIcon } from '@primer/octicons-react';
import * as React from 'react';
export default {
  Icons,
  HeartFillIcon,
  React
};